module.exports = __webpack_public_path__ + "img/男孩4.7a520372.png";